module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Wine-e7e4fb834363fc29e59ae3b7c52e2dc2a55ca058863aa64602072c67ab8684c2.svg";